import { CLICKED_BUTTON, NA } from './analytics.constants'

export const PUB_TAG = {}

PUB_TAG.PUB_MULTIPATH_RESULTAT_TOP = {
  tag_id: 'PUB_MULTIPATH_RESULTAT_TOP',
  onsitead_campaign: 'multipath',
  onsitead_creation: '#provider',
  onsitead_variant: '#mode',
  onsitead_format: '#PageActive',
  onsitead_general_placement: 'result_#selectionslider_resultatTop'
}

PUB_TAG.PUB_MULTIPATH_RESULTAT = {
  tag_id: 'PUB_MULTIPATH_RESULTAT',
  onsitead_campaign: 'multipath',
  onsitead_creation: '#provider',
  onsitead_variant: '#mode',
  onsitead_format: '#PageActive',
  onsitead_general_placement: 'result_#selectionslider_resultat'
}

PUB_TAG.PUB_MULTIPATH_TRAIN_NO_RESULT = {
  tag_id: 'PUB_MULTIPATH_TRAIN_NO_RESULT',
  onsitead_campaign: 'multipath',
  onsitead_creation: '#provider',
  onsitead_variant: '#mode',
  onsitead_format: '#PageActive',
  onsitead_general_placement: 'train_no_result'
}

PUB_TAG.PUB_ATC_MULTIPATH_TRI_RESULTAT = {
  tag_id: 'PUB_ATC_MULTIPATH_TRI_RESULTAT',
  onsitead_campaign: 'multipath',
  onsitead_creation: NA,
  onsitead_variant: '#mode',
  onsitead_format: '#PageActive',
  onsitead_general_placement: 'tri_resultat',
  onsitead_detailed_placement: '#libelle_CTA'
}

PUB_TAG.PUB_MULTIPATH_VOIRPLUSDETRAJETS = {
  tag_id: 'PUB_MULTIPATH_VOIRPLUSDETRAJETS',
  onsitead_campaign: 'multipath',
  onsitead_creation: '#provider',
  onsitead_variant: '#mode',
  onsitead_format: '#PageActive',
  onsitead_general_placement: 'result_#selectionslider_voirplusdetrajets'
}

PUB_TAG.PUB_MULTIPATH_ROADBOOK = {
  tag_id: 'PUB_MULTIPATH_ROADBOOK',
  onsitead_campaign: 'multipath',
  onsitead_creation: '#provider',
  onsitead_variant: '#mode',
  onsitead_format: '#PageActive',
  onsitead_general_placement: 'goto_roadbook'
}

PUB_TAG.PUB_MULTIPATH_GOTO = {
  tag_id: 'PUB_MULTIPATH_GOTO',
  onsitead_campaign: 'multipath',
  onsitead_creation: '#provider',
  onsitead_variant: '#mode',
  onsitead_format: '#PageActive',
  onsitead_general_placement: 'goto',
  onsitead_detailed_placement: '#placement'
}

PUB_TAG.PUB_MULTIPATH_GOTO_MOBILE = {
  tag_id: 'PUB_MULTIPATH_GOTO_MOBILE',
  onsitead_campaign: 'multipath',
  onsitead_creation: '#provider',
  onsitead_variant: '#mode',
  onsitead_format: '#PageActive',
  onsitead_general_placement: 'goto_mobile'
}

PUB_TAG.PUB_MULTIPATH_GOTO_MOBILE_POI = {
  tag_id: 'PUB_MULTIPATH_GOTO_MOBILE_POI',
  onsitead_campaign: NA,
  onsitead_creation: '#Rubrique',
  onsitead_variant: '#Application',
  onsitead_format: '#PageActive',
  onsitead_general_placement: 'goto_mobile'
}

PUB_TAG.PUB_MULTIPATH_GPS = {
  tag_id: 'PUB_MULTIPATH_GPS',
  onsitead_campaign: 'multipath',
  onsitead_creation: '#provider',
  onsitead_variant: '#mode',
  onsitead_format: '#PageActive',
  onsitead_general_placement: 'goto_gps'
}

PUB_TAG.PUB_MULTIPATH_SURMAROUTE = {
  tag_id: 'PUB_MULTIPATH_SURMAROUTE',
  onsitead_campaign: NA,
  onsitead_creation: NA,
  onsitead_variant: '#mode_#distance',
  onsitead_format: '#PageActive',
  onsitead_general_placement: 'surmaroute'
}

PUB_TAG.PUB_ATI_MULTIPATH_BONS_PLANS_DEPLACEMENT = {
  tag_id: 'PUB_ATI_MULTIPATH_BONS_PLANS_DEPLACEMENT',
  onsitead_campaign: 'multipath',
  onsitead_creation: NA,
  onsitead_variant: NA,
  onsitead_format: '#PageActive',
  onsitead_general_placement: 'Bons_plans'
}

PUB_TAG.PUB_ATC_MULTIPATH_BONS_PLANS_DEPLACEMENT = {
  tag_id: 'PUB_ATC_MULTIPATH_BONS_PLANS_DEPLACEMENT',
  onsitead_campaign: 'multipath',
  onsitead_creation: NA,
  onsitead_variant: NA,
  onsitead_format: '#PageActive',
  onsitead_general_placement: 'Bons_plans_#PartnerLabel'
}

PUB_TAG.PUB_FEUILLE_DE_ROUTE_BANDEAU_RESTRICTION = {
  tag_id: 'PUB_FEUILLE_DE_ROUTE_BANDEAU_RESTRICTION',
  onsitead_campaign: 'multipath',
  onsitead_creation: NA,
  onsitead_variant: NA,
  onsitead_format: '#PageActive',
  onsitead_general_placement: 'bandeau_restriction'
}

PUB_TAG.PUB_MULTIPATH_BOOKING_SEARCH_EXTENSION = {
  tag_id: 'PUB_MULTIPATH_BOOKING_SEARCH_EXTENSION',
  onsitead_campaign: 'multipath',
  onsitead_creation: '#codePostalDepart:#codePostalArrivee',
  onsitead_variant: '#distance',
  onsitead_format: '#PageActive',
  onsitead_general_placement: 'goto_booking_search_extension',
  onsitead_detailed_placement: '#causeEchec'
}

PUB_TAG.PUB_FICHEPOI_SITE = {
  tag_id: 'PUB_FICHEPOI_SITE',
  onsitead_campaign: '#Rubrique',
  onsitead_creation: '#Application',
  onsitead_format: '#PageActive',
  onsitead_general_placement: 'gotoSite',
  onsitead_detailed_placement: '#Disponibilite'
}

PUB_TAG.PUB_FICHEPOI_EMAIL = {
  tag_id: 'PUB_FICHEPOI_EMAIL',
  onsitead_campaign: '#Rubrique',
  onsitead_creation: '#Application',
  onsitead_format: '#PageActive',
  onsitead_general_placement: 'email',
  onsitead_detailed_placement: '#Disponibilite'
}

PUB_TAG.PUB_FICHEPOI_AFFICHERNUMERO = {
  tag_id: 'PUB_FICHEPOI_AFFICHERNUMERO',
  onsitead_campaign: '#Rubrique',
  onsitead_creation: '#Application',
  onsitead_format: '#PageActive',
  onsitead_general_placement: 'afficherNumero',
  onsitead_detailed_placement: '#Disponibilite'
}

PUB_TAG.PUB_FICHEPOI_CALL = {
  tag_id: 'PUB_FICHEPOI_CALL',
  onsitead_campaign: '#Rubrique',
  onsitead_creation: '#Application',
  onsitead_format: '#PageActive',
  onsitead_general_placement: 'gotoCall',
  onsitead_detailed_placement: '#Disponibilite'
}

PUB_TAG.PUB_FICHEPOI_REDIRECTIONRESERVATION = {
  tag_id: 'PUB_FICHEPOI_REDIRECTIONRESERVATION',
  onsitead_campaign: '#Rubrique',
  onsitead_creation: '#Application',
  onsitead_format: '#PageActive',
  onsitead_general_placement: 'goto',
  onsitead_detailed_placement: '#Disponibilite',
  mv_test: '#testId',
  mv_creation: '#variantId',
  bouton_clique: `#${CLICKED_BUTTON}`
}

PUB_TAG.PUB_LISTEREPONSE_REDIRECTIONRESERVATION = {
  tag_id: 'PUB_LISTEREPONSE_REDIRECTIONRESERVATION',
  onsitead_campaign: '#Rubrique',
  onsitead_creation: '#Application',
  onsitead_format: '#PageActive',
  onsitead_general_placement: 'goto',
  onsitead_detailed_placement: '#Disponibilite'
}

PUB_TAG.PUB_AFFICHAGE_BARRECATEGORIE = {
  tag_id: 'PUB_AFFICHAGE_BARRECATEGORIE',
  onsitead_campaign: 'BarreDeCategorie',
  onsitead_creation: NA,
  onsitead_variant: '#catId',
  onsitead_format: '#PageActive'
}

PUB_TAG.PUB_LANDING_ACTIVITE_VILLE_FAQ = {
  tag_id: 'PUB_LANDING_ACTIVITE_VILLE_FAQ',
  onsitead_campaign: '#Rubrique',
  onsitead_creation: NA,
  onsitead_variant: 'FAQ',
  onsitead_format: '#PageActive'
}

PUB_TAG.PUB_LANDING_ITINERAIRE_FAQ = {
  tag_id: 'PUB_LANDING_ITINERAIRE_FAQ',
  onsitead_campaign: '#mode',
  onsitead_creation: NA,
  onsitead_variant: 'FAQ',
  onsitead_format: '#PageActive'
}

PUB_TAG.PUB_COMPTE_PERSO_INCITATION = {
  tag_id: 'PUB_COMPTE_PERSO_INCITATION',
  onsitead_campaign: 'ComptePerso',
  onsitead_creation: NA,
  onsitead_variant: NA,
  onsitead_format: '#PageActive',
  onsitead_general_placement: '#Incitation'
}

PUB_TAG.PUB_MAP_POP_IN_MAP_TOO_SLOW = {
  tag_id: 'PUB_MAP_POP_IN_MAP_TOO_SLOW',
  onsitead_campaign: 'Carte',
  onsitead_creation: NA,
  onsitead_variant: NA,
  onsitead_format: '#PageActive',
  onsitead_general_placement: 'pop_in_carte_trop_lente'
}

PUB_TAG.PUB_BANNIERE_EDITO_PUB = {
  tag_id: 'PUB_BANNIERE_EDITO_PUB',
  onsitead_campaign: 'Carte',
  onsitead_creation: NA,
  onsitead_variant: NA,
  onsitead_format: '#PageActive',
  onsitead_general_placement: 'banniere_edito_pub'
}

PUB_TAG.PUB_MAP_LEGENDE_LAYER_CARTE = {
  tag_id: 'PUB_MAP_LEGENDE_LAYER_CARTE',
  onsitead_campaign: 'Carte',
  onsitead_creation: '#title_popin',
  onsitead_variant: NA,
  onsitead_format: '#PageActive',
  onsitead_general_placement: 'legende_layer_carte'
}

PUB_TAG.PUB_MULTIPATH_TC_NO_RESULT = {
  tag_id: 'PUB_MULTIPATH_TC_NO_RESULT',
  onsitead_campaign: 'multipath',
  onsitead_creation: '#provider',
  onsitead_variant: '#mode',
  onsitead_format: '#PageActive',
  onsitead_general_placement: 'tc_no_result'
}
